export default "__VITE_PUBLIC_ASSET__943bdd7e__"